// Initialize Mixpanel
import mixpanel from "mixpanel-browser";

export const startMixPanel = (
  delegateId,
  email,
  name,
  organization,
  groupName
) => {
  const delegateType =
    organization !== "Heart of God Church" ? "Delegate" : "Host";

  if (organization === "Heart of God Church") {
    return;
  }
  // Initialize Mixpanel with your project token
  mixpanel.init(process.env.VUE_APP_MIXPANEL_API_TOKEN, {
    autocapture: true,
    ip: true,
    track_pageview: true, // Automatically track page views
    persistence: "localStorage", // Use localStorage for persistence
    record_sessions_percent: 100,
    record_heatmap_data: true,
    record_block_selector: "",
    record_mask_text_selector: "",
  });
  mixpanel.identify(delegateId);
  mixpanel.people.set({
    $name: name,
    $church: organization,
    $team: groupName,
    $email: email,
  });

  // To restart the session, use anonymize
};

// Export mixpanel for use in other modules
export default mixpanel;
